<template>
    <section id="partners" class="py-20 lg:py-28 bg-secondary">
        <div class="container mx-auto px-4">
            <h2 v-if="content.heading" class="text-3xl md:text-4xl font-bold text-center text-foreground mb-4">
                {{ content.heading }}
            </h2>
            <p v-if="content.subheading" class="text-center text-muted-foreground mb-14 max-w-2xl mx-auto">
                {{ content.subheading }}
            </p>

            <div v-if="cards.length" class="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
                <div
                    v-for="(card, i) in cards"
                    :key="i"
                    class="bg-card rounded-xl p-8 shadow-sm card-hover border border-border"
                >
                    <div class="w-14 h-14 rounded-lg bg-accent/15 flex items-center justify-center mb-5">
                        <BlockIcon :name="card.icon" class="text-accent" :size="28" />
                    </div>
                    <h3 class="text-xl font-semibold text-foreground mb-3">{{ card.title }}</h3>
                    <p class="text-muted-foreground leading-relaxed" :class="{ 'mb-4': card.tags && card.tags.length }">
                        {{ card.text }}
                    </p>
                    <div v-if="card.tags && card.tags.length" class="flex flex-wrap gap-2">
                        <span
                            v-for="(tag, t) in card.tags"
                            :key="t"
                            class="px-4 py-2 rounded-lg border border-border bg-secondary text-foreground font-semibold text-sm"
                        >
                            {{ tag }}
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="chipGroups.length" class="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
                <div
                    v-for="(group, i) in chipGroups"
                    :key="i"
                    class="bg-card rounded-xl p-8 shadow-sm border border-border"
                >
                    <div class="flex items-center gap-3 mb-5">
                        <BlockIcon :name="group.icon" class="text-accent" :size="24" />
                        <h3 class="text-lg font-semibold text-foreground">{{ group.title }}</h3>
                    </div>
                    <div class="flex flex-wrap gap-2">
                        <span
                            v-for="(tag, t) in group.tags"
                            :key="t"
                            class="px-4 py-2 rounded-full border border-border bg-secondary text-foreground font-medium text-sm"
                        >
                            {{ tag }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BlockIcon from "./BlockIcon.vue";

export default {
    name: "AccreditationBlock",
    components: { BlockIcon },
    props: { content: { type: Object, default: () => ({}) } },
    computed: {
        cards() {
            return this.content.cards || [];
        },
        chipGroups() {
            return this.content.chip_groups || [];
        },
    },
};
</script>
